import React, { createContext, useContext } from 'react';

export type Sdk = 'spark';

export const SDK_LABELS: Record<Sdk, string> = {
  spark: 'Breez SDK - Spark',
};

interface SdkContextType {
  sdk: Sdk;
}

const SdkContext = createContext<SdkContextType>({ sdk: 'spark' });

export const SdkProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <SdkContext.Provider value={{ sdk: 'spark' }}>
    {children}
  </SdkContext.Provider>
);

export const useSdk = () => useContext(SdkContext);
